import { useEffect, useState } from "react";
import { navItems } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-[68px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 shrink-0">
          <span
            className={`w-9 h-9 rounded-lg flex items-center justify-center font-heading text-lg ${
              scrolled ? "bg-accent-500 text-background-50" : "bg-accent-500 text-background-50"
            }`}
          >
            家
          </span>
          <span
            className={`font-heading text-lg tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            我的家庭教师
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap pointer-events-auto ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-700 hover:bg-primary-50"
                  : "text-background-50/90 hover:text-background-50 hover:bg-white/10"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#channels"
            className={`hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm whitespace-nowrap transition-colors ${
              scrolled
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50 text-foreground-950 hover:bg-background-100"
            }`}
          >
            <i className="ri-play-circle-line" />
            观看入口
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 rounded-md flex items-center justify-center ${
              scrolled ? "text-foreground-950 bg-background-100" : "text-background-50 bg-white/10"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-4">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="px-3 py-2 rounded-md text-sm text-foreground-700 bg-background-100 hover:bg-primary-50 hover:text-primary-700 transition-colors"
              >
                {item.label}
              </a>
            ))}
          </div>
          <a
            href="#channels"
            onClick={() => setOpen(false)}
            className="mt-3 flex items-center justify-center gap-2 px-4 py-2.5 rounded-md text-sm bg-primary-500 text-background-50"
          >
            <i className="ri-play-circle-line" />
            查看观看入口
          </a>
        </div>
      )}
    </header>
  );
}